function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.349 13.3362L10 13.1527L9.65099 13.3362L6.29382 15.1011L6.93498 11.3629L7.00163 10.9742L6.71928 10.699L4.00327 8.05154L7.75671 7.50614L8.14691 7.44944L8.32141 7.09586L10 3.69466L11.6786 7.09586L11.8531 7.44944L12.2433 7.50614L15.9967 8.05154L13.2807 10.699L12.9984 10.9742L13.065 11.3629L13.7062 15.1011L10.349 13.3362Z",
  stroke: "currentColor",
  strokeWidth: 1.5
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/starred.25d22279.svg";
export { SvgComponent as ReactComponent };